import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProfileService from "../../services/profile.service";



export const getProfile = createAsyncThunk(
  "profile/getProfile",
  async (params, thunkAPI) => {
    try {
      const response = await ProfileService.getProfile(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getSubCaste = createAsyncThunk(
  "profile/getSubCaste",
  async (params, thunkAPI) => {
    try {
      const response = await ProfileService.getSubCaste(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);
export const getPrivacy = createAsyncThunk(
  "profile/getPrivacy",
  async (params, thunkAPI) => {
    try {
      const response = await ProfileService.getPrivacy(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const getRecentActivity = createAsyncThunk(
  "profile/getRecentActivity",
  async (params, thunkAPI) => {
    try {
      const response = await ProfileService.getRecentActivity(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const editPrivacy = createAsyncThunk(
  "profile/editPrivacy",
  async (data, thunkAPI) => {
    try {
      const response = await ProfileService.editPrivacy(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async (payload, thunkAPI) => {
    try {
      const response = await ProfileService.editProfile(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const deletePhoto = createAsyncThunk(
  "profile/deletePhoto",
  async (payload, thunkAPI) => {
    try {
      const response = await ProfileService.deletePhoto(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const updateProfessionalDetails = createAsyncThunk(
  "updateprofessionaldetails/updateProfessionalDetails",
  async (payload, thunkAPI) => {
    try {
      const response = await ProfileService.editProfessionalDetails(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const updateFamilyDetails = createAsyncThunk(
  "updatefamilydetails/updateFamilyDetails",
  async (payload, thunkAPI) => {
    try {
      const response = await ProfileService.editFamilyDetails(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);





export const deleteProfile = createAsyncThunk(
  "profile/deleteProfile",
  async (id, thunkAPI) => {
    try {
      await ProfileService.deleteProfile(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  subCasteLoading: false,
  error: null,
  profilelist: {},
  privacy: {
    profileVisibleTo: "Connections",
    connectionRequests: "Everyone",
    profileViews: "Connections",
    photoVisibility: "Connections",
  },
  activity: [],
  subcaste: [],
  updateSuccess: false,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getSubCaste.pending, (state) => {
        state.subCasteLoading = true;
      })
      .addCase(getSubCaste.fulfilled, (state, action) => {
        console.log(action.payload);
        state.subCasteLoading = false;
        state.subcaste = action.payload?.data || [];
      })
      .addCase(getSubCaste.rejected, (state, action) => {
        state.subCasteLoading = false;
      })
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profilelist = action.payload?.data || {};
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Get Privacy ---------- */
      .addCase(getPrivacy.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPrivacy.fulfilled, (state, action) => {
        state.loading = false;
        state.privacy = action.payload?.data || {};
      })
      .addCase(getPrivacy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deletePhoto.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePhoto.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.data;
      })
      .addCase(deletePhoto.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getRecentActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRecentActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.activity = Array.isArray(action.payload?.data)
          ? action.payload.data
          : [];
      })
      .addCase(getRecentActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update Privacy ---------- */
      .addCase(editPrivacy.pending, (state) => {
        state.loading = true;
      })
      .addCase(editPrivacy.fulfilled, (state, action) => {
        state.loading = false;
        state.privacy = {
          ...state.privacy,
          ...(action.payload?.data || {}),
        };
      })
      .addCase(editPrivacy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      /* ---------- Update ---------- */
      // updateProfile
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        state.profilelist =
          action.payload?.data ||
          action.payload?.profileData ||
          state.profilelist;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      /* ---------- Delete ---------- */
      .addCase(deleteProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profilelist = state.profilelist.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = profileSlice.actions;
export default profileSlice.reducer;
